import FirebaseService from "../services/FirebaseService"

export default FirebaseService.instance()
